/** @jsx jsx */
import { jsx } from '@emotion/core'
import React from 'react'
import { Row as DefaultRow } from './components'
import styled from 'styled-components'
import { Input, Button, InputNumber } from 'antd'
import { cronToBasic, describeCron } from './utils'
const Row = styled(DefaultRow)`
  &:nth-child(odd) {
    background-color: #f4f4f4;
  }
  padding-right: 10px;
`
const CronDesciption = styled.div`
  display: flex;
  flex: 1 0 200px;
  background-color: ${({ valid }) => (valid ? 'unset' : 'rgba(255,0,0,.1)')};
  color: ${({ valid }) => (valid ? 'unset' : 'brown')};
  align-items: center;
  height: 28.8px;
  padding: 0 5px;
  font-weight: ${({ valid }) => (valid ? 'unset' : 'bold')};
`

// const CronDesciption = ({cron}) =>

class TriggerRow extends React.Component {
  constructor(props) {
    super(props)
    this.dataChanged = this.dataChanged.bind(this)
    this.saveData = this.saveData.bind(this)
    this.cancelEdit = this.cancelEdit.bind(this)
    const { cronExpression = '0 0 0 * * ?' } = this.props
    const cronData = cronExpression.split(' ')
    const isCronMode =
      cronData[0] !== '0' ||
      cronData[3] !== '*' ||
      cronData[4] !== '*' ||
      cronData[5] !== '?'
    this.state = {
      edited: false,
      minute: cronData[1],
      hour: cronData[2],
      mode: isCronMode ? 'cron' : 'basic',
      cronExpression: cronExpression,
      cron: describeCron(cronExpression),
    }
  }

  toCron = _ =>
    // eslint-disable-next-line no-unused-vars
    this.setState(({ hour, minute, cronExpression }) => ({
      mode: 'cron',
      edited: cronExpression !== this.props.cronExpression,
    }))

  toBasic = _ =>
    this.setState(({ hour, minute, cronExpression, cron }) => ({
      mode: 'basic',
      cronExpression: cron.success
        ? cronToBasic(cronExpression)
        : `0 ${hour} ${minute} * * ?`,
      edited:
        (cron.success
          ? cronToBasic(cronExpression)
          : `0 ${hour} ${minute} * * ?`) !== this.props.cronExpression,
    }))

  dataChanged(e) {
    const { name, value } = e.target
    this.setState(state => {
      const newState = { ...state, [name]: value }
      const { minute, hour } = newState
      const cronExpression =
        newState.mode === 'basic'
          ? `0 ${minute == null ? '0' : minute} ${
              hour == null ? '0' : hour
            } * * ?`
          : newState.cronExpression
      const cron = describeCron(cronExpression)
      return {
        ...newState,
        cronExpression,
        cron,
        edited: cronExpression !== this.props.cronExpression,
      }
    })
  }

  saveData() {
    const { cronExpression } = this.state
    const { name, triggerId, triggerType, save } = this.props
    if (save) {
      save({
        name,
        triggerId,
        triggerType,
        cronExpression,
      }).fork(
        _ => _,
        () => this.setState({ edited: false })
      )
    }
  }

  componentDidUpdate(prevProps) {
    /* eslint-disable react/no-did-update-set-state */
    if (prevProps !== this.props) this.setState({ edited: false })
    /* eslint-enable react/no-did-update-set-state */
  }

  cancelEdit() {
    const cronData = this.props.cronExpression.split(' ')
    const isCronMode =
      cronData[0] !== '0' ||
      cronData[3] !== '*' ||
      cronData[4] !== '*' ||
      cronData[5] !== '?'
    this.setState({
      edited: false,
      mode: isCronMode ? 'cron' : 'basic',
      minute: cronData[1],
      hour: cronData[2],
      cronExpression: this.props.cronExpression,
      cron: describeCron(this.props.cronExpression),
    })
  }

  render() {
    const { CellWrapper, dataWidth, name } = this.props

    const { minute, hour, edited, mode, cronExpression, cron } = this.state

    return (
      <Row>
        <Button.Group
          style={{
            minWidth: '130px',
            width: '130px',
            display: 'grid',
            gridTemplateColumns: '60px 60px',
          }}
        >
          <Button
            onClick={this.toBasic}
            style={{
              backgroundColor: mode === 'basic' ? 'black' : undefined,
              color: mode === 'basic' ? 'white' : undefined,
            }}
          >
            Basic
          </Button>

          <Button
            onClick={this.toCron}
            style={{
              backgroundColor: mode === 'cron' ? 'black' : undefined,
              color: mode === 'cron' ? 'white' : undefined,
            }}
          >
            Cron*
          </Button>
        </Button.Group>
        <CellWrapper css={{ minWidth: '200px', marginLeft: '10px' }}>
          {name}
        </CellWrapper>
        {mode === 'basic' && (
          <CellWrapper width={dataWidth}>
            <InputNumber
              name="hour"
              fluid
              value={hour}
              min={0}
              max={23}
              onChange={val =>
                this.dataChanged({ target: { name: 'hour', value: val } })
              }
            />
          </CellWrapper>
        )}
        {mode === 'basic' && (
          <CellWrapper width={dataWidth}>
            <InputNumber
              name="minute"
              style={{ width: '100px' }}
              value={minute}
              onChange={val =>
                this.dataChanged({ target: { name: 'minute', value: val } })
              }
              min={0}
              max={59}
            />
          </CellWrapper>
        )}

        {mode === 'cron' && (
          <CellWrapper width="200px">
            <Input
              name="cronExpression"
              style={{ width: '200px' }}
              value={cronExpression}
              onChange={this.dataChanged}
            />
          </CellWrapper>
        )}

        {edited && [
          <Button
            disabled={!cron.success}
            key="save"
            type="primary"
            onClick={this.saveData}
          >
            Save
          </Button>,
          <Button
            key="cancel"
            secondary
            onClick={this.cancelEdit}
            style={{ marginLeft: '10px' }}
          >
            Cancel
          </Button>,
        ]}
        <CronDesciption valid={cron.success}>{cron.description}</CronDesciption>
      </Row>
    )
  }
}
export default TriggerRow
